import { RouteObject } from 'react-router-dom';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { Authorize } from '@/components';
import { ErrorPage } from '@/pages/Layout/pages';
import { PickupCycles } from '@/pages/Business/pages/PickupCycles/PickupCycles';

const PickupCyclesRoutes: RouteObject[] = [
  {
    path: 'pickup-cycles',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.full}
        fallback={<ErrorPage code={403} />}
      >
        <PickupCycles />
      </Authorize>
    ),
  },
];

export default PickupCyclesRoutes;
